// extracted by mini-css-extract-plugin
export var text = "_77-0";